import React, { useEffect, useState } from "react";
import Mask_Group from '../assets/Mask group.svg';
import Grey_indicator from '../assets/Grey Indicator.svg';

const ReportPopup = ({ open, onClose, token, queryDev, user_session_id, hasShouldCostSummary }) => {
    const [loading, setLoading] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const [error, setError] = useState(null);

    const generateReport = async () => {
        setLoading(true);
        setError(null);
        setResponseData(null);

        const formData = new FormData();
        formData.append("operation", "query");
        formData.append("query", "Please generate a pdf report");
        formData.append("user_session_id", user_session_id);

        try {
            const res = await fetch(queryDev, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const data = await res.json();
            const rawAnswer = data?.answer?.trim() || "";

            // Clean JSON fences if any
            let cleaned = rawAnswer;
            if (cleaned.startsWith("```json")) {
                cleaned = cleaned.replace(/^```json/, "").replace(/```$/, "").trim();
            }

            // Try to parse JSON
            const firstBrace = cleaned.indexOf("{");
            const lastBrace = cleaned.lastIndexOf("}");
            let parsed = null;
            if (firstBrace !== -1 && lastBrace !== -1) {
                parsed = JSON.parse(cleaned.slice(firstBrace, lastBrace + 1));
            }

            // ✅ Success condition
            if (parsed?.type === "pdf_report" && parsed?.download_link) {
                setResponseData(parsed);
            } else {
                setError(
                    rawAnswer.includes("⚠️")
                        ? rawAnswer
                        : "Failed to generate report. Please try again later."
                );
            }
        } catch (err) {
            console.error("Report generation error:", err);
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            if (hasShouldCostSummary) {
                generateReport();
            }
        }
    }, [open, hasShouldCostSummary]);
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-lg p-8 w-[400px] text-center relative">
                {!loading && (
                    <button
                        onClick={onClose}
                        className="absolute top-2 right-3 text-gray-500 hover:text-black"
                    >
                        ✕
                    </button>
                )}
                {!hasShouldCostSummary ? (
                    <div className="text-[14px] text-gray-700">
                        ⚠️ Please generate the <b>Should Cost Summary</b> before creating a PDF report.
                    </div>
                ) : loading ? (
                    <div className="flex flex-col items-center justify-center text-gray-600">
                        <div className="text-center">
                            <span className="relative inline-block w-10 h-10">
                                <img
                                    src={Mask_Group}
                                    alt="Mask_Group"
                                    className="absolute top-0 left-0 w-full h-full animate-spin"
                                />
                                <img
                                    src={Grey_indicator}
                                    alt="Grey_indicator"
                                    className="absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
                                />
                            </span>
                        </div>
                        <p className="mt-3">Generating report, please wait...</p>
                    </div>
                ) : error ? (
                    <div className="text-red-600 text-sm bg-red-50 border border-red-200 rounded p-3 whitespace-pre-wrap">
                        {error}
                    </div>
                ) : responseData ? (
                    <div className="text-[14px]">
                        <p className="font-semibold text-green-700 mb-2">
                            ✅ PDF Report Generated Successfully
                        </p>
                        <a
                            href={responseData.download_link}
                            target="_self"
                            rel="noopener noreferrer"
                            className="text-[#0a58ca] underline font-semibold hover:text-[#460073]"
                        >
                            Click here to download your report
                        </a>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ReportPopup;
